// Mock data for Battlefield Esports Club - Prototype Sports with red branding

export const heroContent = {
  title: "Prototype eSports",
  subtitle: "Master the next generation of warfare",
  ctaText: "Join Our Squad",
  secondaryCta: "View Tournaments"
};

export const teamMembers = [
  {
    name: "Base2k",
    role: "Captain & Wararranger",
    rank: "Founder",
    specialization: "Defence specialist",
    image: `${process.env.PUBLIC_URL}/images/classes/engineer.jpg`,
    achievements: [""]
  },
  {
    name: "JohnBurn",
    role: "Engineer Specialist",
    rank: "Founder",
    specialization: "Defence specialist",
    image: `${process.env.PUBLIC_URL}/images/classes/engineer.jpg`,
    achievements: [""]
  },
  {
    name: "Tutitin",
    role: "Engineer Specialist",
    rank: "Tactics",
    specialization: "Front-line specialist",
    image: `${process.env.PUBLIC_URL}/images/classes/engineer.jpg`,
    achievements: [""]
  },
  {
    name: "Francis",
    role: "Assault Specialist",
    rank: "Rusher",
    specialization: "Front-line specialist",
    image: `${process.env.PUBLIC_URL}/images/classes/assault.jpg`,
    achievements: [""]
  },
  {
    name: "MadnNes",
    role: "Assault Specialist",
    specialization: "Front-line specialist",
    image: `${process.env.PUBLIC_URL}/images/classes/assault.jpg`,
    achievements: [""]
  },
  {
    name: "NexusReplicantZ",
    role: "Assault Specialist",
    specialization: "Front-line specialist",
    image: `${process.env.PUBLIC_URL}/images/classes/assault.jpg`,
    achievements: [""]
  },
  {
    name: "SoloXaxo",
    role: "Assault Specialist",
    specialization: "Front-line specialist",
    image: `${process.env.PUBLIC_URL}/images/classes/assault.jpg`,
    achievements: [""]
  },
  {
    name: "Hervi23",
    role: "Engineer Specialist",
    specialization: "Defence specialist",
    image: `${process.env.PUBLIC_URL}/images/classes/engineer.jpg`,
    achievements: [""]
  },
  {
    name: "SilverHace",
    role: "Helicopter Specialist",
    specialization: "Defence specialist",
    image: `${process.env.PUBLIC_URL}/images/classes/heli.png`,
    achievements: [""]
  },
  {
    name: "Punisher",
    role: "Helicopter Specialist",
    specialization: "Defence specialist",
    image: `${process.env.PUBLIC_URL}/images/classes/heli.png`,
    achievements: [""]
  },
  {
    name: "HansiFlick",
    role: "Assault Specialist",
    rank: "Killer",
    specialization: "Front-line specialist",
    image: `${process.env.PUBLIC_URL}/images/classes/assault.jpg`,
    achievements: [""]
  },
  {
    name: "Xen",
    role: "Helicopter Specialist",
    rank: "Legend",
    specialization: "Front-line specialist",
    image: `${process.env.PUBLIC_URL}/images/classes/heli.png`,
    achievements: [""]
  },
    {
    name: "EdwinDS",
    role: "Assault Specialist",
    specialization: "Front-line specialist",
    image: `${process.env.PUBLIC_URL}/images/classes/assault.jpg`,
    achievements: [""]
  }


];

export const teamRows = [
  {
    label: "",
    members: [
      {
        name: "Base2k",
        role: "Captain & Wararranger",
        rank: "Founder",
        specialization: "Defence specialist",
        image: `${process.env.PUBLIC_URL}/images/classes/engineer.jpg`,
        achievements: [""]
      },
      {
        name: "JohnBurn",
        role: "Engineer Specialist",
        rank: "Founder",
        specialization: "Defence specialist",
        image: `${process.env.PUBLIC_URL}/images/classes/engineer.jpg`,
        achievements: [""]
      },
      {
        name: "XIH",
        role: "Assault Specialist",
        rank: "Founder",
        specialization: "Front-line specialist",
        image: `${process.env.PUBLIC_URL}/images/classes/assault.jpg`,
        achievements: [""]
      },
      {
        name: "R1",
        role: "Assault Specialist",
        rank: "Founder",
        specialization: "Front-line specialist",
        image: `${process.env.PUBLIC_URL}/images/classes/assault.jpg`,
        achievements: [""]
      }
    ]
  },
  {
    label: "",
    members: [
      {
        name: "Francis",
        role: "Assault Specialist",
        rank: "Rusher",
        specialization: "Front-line specialist",
        image: `${process.env.PUBLIC_URL}/images/classes/assault.jpg`,
        achievements: [""]
      },
      {
        name: "MadnNes",
        role: "Assault Specialist",
        rank: "Legend",
        specialization: "Front-line specialist",
        image: `${process.env.PUBLIC_URL}/images/classes/assault.jpg`,
        achievements: [""]
      },
      {
        name: "Dearhell",
        role: "Engineer Specialist",
        rank: "Killer",
        specialization: "Front-line specialist",
        image: `${process.env.PUBLIC_URL}/images/classes/engineer.jpg`,
        achievements: [""]
      },
      {
        name: "Mihajlovicc",
        role: "Assault Specialist",
        rank: "Vamos",
        specialization: "Front-line specialist",
        image: `${process.env.PUBLIC_URL}/images/classes/assault.jpg`,
        achievements: [""]
      },
      {
        name: "Lagii",
        role: "Assault Specialist",
        rank: "Killer",
        specialization: "Front-line specialist",
        image: `${process.env.PUBLIC_URL}/images/classes/assault.jpg`,
        achievements: [""]
      },
    ]
  },
    {
    label: "",
    members: [
      {
        name: "Hervi23",
        role: "Engineer Specialist",
        rank: "IGL",
        specialization: "Defence specialist",
        image: `${process.env.PUBLIC_URL}/images/classes/engineer.jpg`,
        achievements: [""]
      },
      {
        name: "Neo_Bmp",
        role: "Assault Specialist",
        rank: "Killer",
        specialization: "Front-line specialist",
        image: `${process.env.PUBLIC_URL}/images/classes/assault.jpg`,
        achievements: [""]
      },
      {
        name: "Xen",
        role: "Engineer Specialist",
        rank: "Legend",
        specialization: "Defence specialist",
        image: `${process.env.PUBLIC_URL}/images/classes/engineer.jpg`,
        achievements: [""]
      },
    {
        name: "JOTA",
        role: "Assault Specialist",
        specialization: "Front-line specialist",
        image: `${process.env.PUBLIC_URL}/images/classes/assault.jpg`,
        achievements: [""]
      },
      {
        name: "Tinka",
        role: "Assault Specialist",
        specialization: "Front-line specialist",
        image: `${process.env.PUBLIC_URL}/images/classes/assault.jpg`,
        achievements: [""]
      },
    ]
  },
  {
    label: "",
    members: [
      {
        name: "Jabb",
        role: "Engineer Specialist",
        specialization: "Defence specialist",
        image: `${process.env.PUBLIC_URL}/images/classes/engineer.jpg`,
        achievements: [""]
      },
      {
        name: "K2rra",
        role: "Engineer Specialist",
        specialization: "Defence specialist",
        image: `${process.env.PUBLIC_URL}/images/classes/engineer.jpg`,
        achievements: [""]
      },
      {
        name: "Punisher",
        role: "Tank Specialist",
        rank: "Legend",
        specialization: "Defence specialist",
        image: `${process.env.PUBLIC_URL}/images/classes/tank.png`,
        achievements: [""]
      },
      {
        name: "SilverHace",
        role: "Helicopter Specialist",
        rank: "Legend",
        specialization: "Defence specialist",
        image: `${process.env.PUBLIC_URL}/images/classes/heli.png`,
        achievements: [""]
      },
      {
        name: "AlexSupertrammp",
        role: "Tank Specialist",
        specialization: "Defence specialist",
        image: `${process.env.PUBLIC_URL}/images/classes/tank.png`,
        achievements: [""]
      }

    ]
  }
];

export const upcomingEvents = [
  {
    id: 1,
    title: "Battlefield Champions League",
    date: "March 15, 2025",
    time: "7:00 PM EST",
    prize: "$50,000",
    status: "Registered",
    description: "Major Battlefield championship featuring top 32 teams worldwide",
    image: "https://www.gamespot.com/a/uploads/scale_super/1179/11799911/4541536-battlefield6officialmultiplayergameplaytrailer1-50screenshot.png"
  },
  {
    id: 2,
    title: "Spring Conquest Tournament",
    date: "March 28, 2025", 
    time: "6:00 PM EST",
    prize: "$15,000",
    status: "Open Registration",
    description: "Regional Battlefield tournament for emerging squads",
    image: "https://www.gamespot.com/a/uploads/scale_super/1179/11799911/4541521-battlefield6officialmultiplayergameplaytrailer2-9screenshot.png"
  },
  {
    id: 3,
    title: "Battlefield Masters",
    date: "April 10, 2025",
    time: "8:00 PM EST", 
    prize: "$25,000",
    status: "Qualifying",
    description: "Elite tournament featuring the latest Battlefield  content",
    image: "https://www.gamespot.com/a/uploads/scale_super/1179/11799911/4537711-battlefield6officialrevealtrailer0-36screenshot.png"
  }
];

export const aboutContent = {
  mission: "To forge the ultimate Battlefield players through strategic training, competitive excellence, and cutting-edge tactics in next-gen warfare.",
  vision: "Leading the Battlefield esports scene with tactical superiority and unmatched skill.",
  values: [
    "Strategic Excellence",
    "Team Coordination", 
    "Continuous Improvement",
    "Competitive Spirit",
    "Next-Gen Warfare"
  ],
  stats: [
    { label: "Tournament Played", value: "15+" },
    { label: "Active Members", value: "20+" },
    { label: "Years Active", value: "12+" },
    { label: "Win Rate", value: "75.8%" }
  ]
};

export const contactInfo = {
  discord: "https://discord.gg/M8GkwFWTvg",
  social: {
    youtube: "Prototype Sports Official", 
    X: "https://x.com/ProTypeSports",
    discord: "https://discord.gg/M8GkwFWTvg"
  },
  requirements: [
    "Battlefield access required",
    "500+ hours Battlefield experience",
    "Competitive mindset and skills",
    "Team communication abilities",
    "Regular practice availability",
    "Age 18+ required"
  ]
};